import { store } from "../../store";
import api from "./api";

const apiPresets = {
  getVisits: async (opt = {}) => {
    const { filter = {}, where = {}, populate = [] } = opt;
    console.log({ where });

    const { visits } = await api.get("v1/district-admin/visit", {
      filter: JSON.stringify({
        where: {
          district: store.getState().pState.AUTH.user?.district?._id,
          ...where,
        },
        populate: [
          {
            path: "visitor",
            select: "name image designation",
          },
          {
            path: "office",
            populate: [
              {
                path: "subdivision block deptBlock circle lac type",
              },
            ],
          },
          {
            path: "scheme",
            populate: [
              {
                path: "office",
                populate: [
                  {
                    path: "subdivision block deptBlock circle lac type",
                  },
                ],
              },
              {
                path: "subdivision block circle lac",
              },
            ],
          },
          {
            path: "reports",
          },
          ...populate,
        ],
        sortby: "createdAt",
        order: -1,
        ...filter,
      }),
    });

    return visits;
  },
};

export default apiPresets;
